import React from "react";
import './ferramentas.css';

function Ferramentas() {
    return <section id="ferramentas">
        <div className="container">
            <div className="text-center mb-5">
                <h2 className="display-5 fw-bold">Conheça nossas funcionalidades</h2>
            </div>
            <div className="row g-4 justify-content-center">

                {/* Card 1: Controle de clientes */}
                <div className="col-lg-4 col-md-6">
                    <div className="ferramenta-card h-100">
                        <div className="icon-box">
                            <i className="icon fas fa-users fa-3x"></i>
                        </div>
                        <h3>Controle de clientes</h3>
                        <p>Tenha todos os dados dos seus clientes organizados. Acesse histórico de compras, preferências e ofereça um atendimento personalizado que fideliza.</p>
                    </div>
                </div>

                {/* Card 2: Controle de fornecedores */}
                <div className="col-lg-4 col-md-6">
                    <div className="ferramenta-card h-100">
                        <div className="icon-box">
                            <i className="icon fas fa-truck-field fa-3x"></i>
                        </div>
                        <h3>Controle de fornecedores</h3>
                        <p>Centralize informações de contato e produtos. Ganhe agilidade nas negociações com tudo à mão.</p>
                    </div>
                </div>

                {/* Card 3: Gerenciamento de produtos (Novo) */}
                <div className="col-lg-4 col-md-6">
                    <div className="ferramenta-card h-100">
                        <div className="icon-box">
                            <i className="icon fas fa-box-open fa-3x"></i>
                        </div>
                        <h3>Gerenciamento de produtos</h3>
                        <p>Cadastre produtos por fornecedor e controle variações por cor e grade. Mantenha seu catálogo organizado e preciso.</p>
                    </div>
                </div>

                {/* Card 4: Controle por tamanhos (Novo) */}
                <div className="col-lg-4 col-md-6">
                    <div className="ferramenta-card h-100">
                        <div className="icon-box">
                            <i className="icon fas fa-ruler-combined fa-3x"></i>
                        </div>
                        <h3>Controle por tamanhos</h3>
                        <p>Cadastre as grades do seu produto e realize o controle por tamanhos. Facilite seu controle de vendas de caixas fechadas.</p>
                    </div>
                </div>

                {/* Card 5: Cadastro de pedidos */}
                <div className="col-lg-4 col-md-6">
                    <div className="ferramenta-card h-100">
                        <div className="icon-box">
                            <i className="icon fas fa-file-invoice fa-3x"></i>
                        </div>
                        <h3>Cadastro de pedidos</h3>
                        <p>Emita pedidos de forma rápida e profissional. Reduza erros operacionais e impressione seus clientes com agilidade.</p>
                    </div>
                </div>

                {/* Card 6: Geração de financeiro integrado */}
                <div className="col-lg-4 col-md-6">
                    <div className="ferramenta-card h-100">
                        <div className="icon-box">
                            <i className="icon fas fa-gears fa-3x"></i>
                        </div>
                        <h3>Geração de financeiro integrado</h3>
                        <p>Diga adeus ao retrabalho. Ao fechar um pedido, o sistema gera os lançamentos financeiros a pagar e a receber, poupando seu tempo.</p>
                    </div>
                </div>

                {/* Card 7: Controle financeiro a pagar e receber */}
                <div className="col-lg-4 col-md-6">
                    <div className="ferramenta-card h-100">
                        <div className="icon-box">
                            <i className="icon fas fa-chart-pie fa-3x"></i>
                        </div>
                        <h3>Controle financeiro</h3>
                        <p>Domine seu fluxo de caixa. Visualize claramente o que tem a pagar e receber para tomar decisões seguras e lucrativas.</p>
                    </div>
                </div>

            </div>
        </div>

    </section>;
}

export default Ferramentas;